<template>
  <div>
    <component
      v-for="part in parts"
      :is="UserFormPart(part.part_type)"
      :key="part.id"
      :userFormId="userFormId"
      :section="part"
      :question="part"
      :paragraph="part"
      :read-only="part.read_only || readOnly"
      :class="{'pdfpart': part.pdf_only}"
    />
  </div>
</template>

<script>

import UserFormSection from './UserFormSection'
import UserFormQuestion from './UserFormQuestion'
import UserFormParagraph from './UserFormParagraph'
import UserFormESignature from './UserFormESignature'
import UserFormPageBreak from './UserFormPageBreak'

export default {
  name: 'UserFormPartList',
  props: [ 'userFormId', 'parts', 'readOnly'],
  components: {
    UserFormSection,
    UserFormQuestion,
    UserFormParagraph,
    UserFormESignature,
    UserFormPageBreak
  },
  methods: {
    UserFormPart (PartType) {
      switch (PartType) {
        case 's':
          return 'UserFormSection'
        case 'q':
          return 'UserFormQuestion'
        case 'p':
          return 'UserFormParagraph'
        case 'e':
          return 'UserFormESignature'
        case 'b':
          return 'UserFormPageBreak'
      }
    }
  }
}
</script>

<style scoped>
.pdfpart {
  opacity: 0.4;
}
</style>